// extracted by mini-css-extract-plugin
module.exports = {"pageBtn":"pageitem_pageBtn__RtENu","xs":"pageitem_xs__2Zgxy"};